import { Check, Slash } from 'lucide-react';
import Section from './Section.jsx';

// On mobile the same three picks already render in the score card (canonical,
// per-persona) and the narrative, so the grid shows only the SKIP cards there
// — the one thing the score card doesn't carry. Desktop has the room to keep
// both sides.
export default function PicksAndAvoid({ items }) {
  if (!items?.length) return null;
  const hasSkips = items.some((item) => item.type !== 'pick');
  return (
    <div className={hasSkips ? undefined : 'hidden sm:block'}>
      <Section
        title={
          <>
            <span className="sm:hidden">What to skip</span>
            <span className="hidden sm:inline">Picks and what to skip</span>
          </>
        }
        eyebrow="Today's read"
      >
        <div className="grid gap-3 sm:grid-cols-2">
          {items.map((item, i) => {
            const isPick = item.type === 'pick';
            return (
              <div
                key={i}
                // Accented card: cream tint with a left rule carrying the
                // semantic color, matching the guide callouts and Tonight in
                // Town. Replaces two separate full-border card styles.
                className={[
                  'rounded-xl border border-navy-100 border-l-2 bg-cream-100/60 px-5 py-4',
                  isPick ? 'hidden border-l-marsh-500 sm:block' : 'border-l-navy-300'
                ].join(' ')}
              >
                <div className="mb-1.5 flex items-center gap-2">
                  {isPick ? (
                    <Check className="h-4 w-4 text-marsh-600" />
                  ) : (
                    <Slash className="h-4 w-4 text-navy-500" />
                  )}
                  <span
                    className={[
                      'text-xs font-semibold uppercase tracking-wider',
                      isPick ? 'text-marsh-700' : 'text-navy-500'
                    ].join(' ')}
                  >
                    {isPick ? 'Pick' : 'Skip'}
                  </span>
                </div>
                <h3 className="mb-1 font-display text-base font-semibold text-navy-900">
                  {item.title}
                </h3>
                <p className="text-sm leading-relaxed text-navy-700">{item.body}</p>
              </div>
            );
          })}
        </div>
      </Section>
    </div>
  );
}
